import moment from 'moment'

import { PAD_TYPE, PLANNED_TYPE, REAL_TYPE } from './displayRules'

const durationDisplayCaseSixAB = (cardType, typeStart, plannedDuration) => {
  if (cardType === PAD_TYPE) {
    return `${moment(typeStart).format('HH:mm')} - Aucun`
  }
  if (cardType === REAL_TYPE) {
    return `${plannedDuration} min (${moment(typeStart).format(
      'HH:mm'
    )} - ${moment(typeStart).add(plannedDuration, 'minutes').format('HH:mm')}) `
  }
}

const durationDisplayCaseSixC = (cardType, isFirst, typeStart) => {
  if (cardType === REAL_TYPE) {
    if (!isFirst) {
      return
    }
    return 'Aucun'
  }
  if (cardType === PAD_TYPE) {
    return `${moment(typeStart).format('HH:mm')} - Aucun`
  }
}

const durationDisplayCaseFiveC = (
  cardType,
  typeDuration,
  typeStart,
  typeEnd
) => {
  if (cardType === REAL_TYPE) {
    return `${typeDuration} min ${
      typeStart
        ? `(${moment(typeStart).format('HH:mm')} - ${moment(typeEnd).format(
            'HH:mm'
          )}) `
        : ''
    }`
  }
  if (cardType === PAD_TYPE) {
    return 'Aucun'
  }
}

const formCase = (breakId, typeDuration, typeStart, typeEnd) => {
  return {
    value: {
      id: breakId || null,
      plannedDuration: typeDuration,
      ...(typeStart
        ? {
            timeRange: [
              moment(typeStart).format('HH:mm'),
              moment(typeEnd).format('HH:mm')
            ]
          }
        : {})
    }
  }
}

// Please READ THIS FILE => https://docs.google.com/spreadsheets/d/1fPyoU5Zt_yrURq3hG1EH_hL9QSq4JmjhZfw5jyRp6aM/edit#gid=0

/**
 * @deprecated
 */
export const displayRulesLegacy = (
  breakId = undefined,
  breakAsReal: boolean,
  shiftEventsSize: number,
  plannedDuration: number,
  shiftIsFinishedWithoutOut: boolean,
  typeStart: string,
  cardType: string,
  isFirst: boolean,
  typeDuration: number,
  typeEnd: string,
  isForm = false,
  hasSnapPad = false
) => {
  let ruleResult = null
  if (cardType === PLANNED_TYPE || !hasSnapPad) {
    return ruleResult
  }

  /* CAS 6.a && 6.b  */
  if (
    breakAsReal &&
    shiftEventsSize === 1 &&
    plannedDuration &&
    plannedDuration > 0 &&
    shiftIsFinishedWithoutOut
  ) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    ruleResult = isForm
      ? formCase(breakId, typeDuration, typeStart, typeEnd)
      : durationDisplayCaseSixAB(cardType, typeStart, plannedDuration)
  }

  /* CAS 6.c */
  if (
    breakAsReal &&
    shiftEventsSize === 1 &&
    plannedDuration === 0 &&
    shiftIsFinishedWithoutOut
  ) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    ruleResult = isForm
      ? null
      : durationDisplayCaseSixC(cardType, isFirst, typeStart)
  }

  /* CAS 5.c */
  if (
    breakAsReal &&
    plannedDuration &&
    shiftEventsSize < 1 &&
    shiftIsFinishedWithoutOut
  ) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    ruleResult = isForm
      ? formCase(breakId, typeDuration, typeStart, typeEnd)
      : durationDisplayCaseFiveC(cardType, typeDuration, typeStart, typeEnd)
  }

  /* CAS 5.b  */
  if (
    breakAsReal &&
    plannedDuration &&
    shiftEventsSize < 1 &&
    !shiftIsFinishedWithoutOut
  ) {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    ruleResult = isForm ? null : '0 min'
  }

  return ruleResult
}
